export const roles = [
  { value: "architects", label: "Architects" },
  { value: "builders-home-users", label: "Builders, home users" },
  { value: "electrical-planner", label: "Electrical planner" },
  { value: "interior-designers", label: "Interior designers" },
  { value: "landscape-architects", label: "Landscape architects" },
  { value: "lighting-designer", label: "Lighting designer" },
  { value: "professor-teacher", label: "Professor / Teacher" },
  { value: "sales-admin-it", label: "Sales / Admin / IT" },
  { value: "student", label: "Student" },
  { value: "installers", label: "Installers" },
  { value: "other", label: "Other" },
];
